import {
  OwcAvatar,
  OwcButton,
  OwcComponentFooter,
  OwcComponentHeader,
  OwcTypography,
} from '@one/react';
import { useTranslation } from 'core/i18n';
import { useNativeBackButton } from 'core/platform/use-native-back-button.hook';
import { PropsWithChildren, useId, useState } from 'react';
import { UserAvatarMenu } from './user-avatar-menu.style';

interface UserMenuAvatarComponentProps extends PropsWithChildren {
  initials: string;
  header: string;
  onLogout: VoidFunction;
}

export const UserMenuAvatarComponent: React.FC<UserMenuAvatarComponentProps> = props => {
  const { initials, header, children, onLogout } = props;

  const id = `user-avatar-menu-${useId().replaceAll(':', '')}`;
  const { t } = useTranslation('common');
  const [visible, setVisible] = useState(false);

  useNativeBackButton(() => setVisible(false), visible);

  return (
    <OwcAvatar interactive id={id}>
      {initials}
      <UserAvatarMenu
        trigger="click"
        anchor={id}
        offset={[0, 8]}
        autoCloseOnSelection
        visible={visible}
        onVisibleChange={event => setVisible(event.detail)}
      >
        <OwcComponentHeader slot="header" separator>
          <OwcTypography variant="subtitle1">{header}</OwcTypography>
        </OwcComponentHeader>
        {children}
        <OwcComponentFooter slot="footer">
          <OwcButton variant="secondary" slot="suffix" onClick={onLogout}>
            {t('components.user-avatar-menu.logout')}
          </OwcButton>
        </OwcComponentFooter>
      </UserAvatarMenu>
    </OwcAvatar>
  );
};
